import { motion } from "framer-motion";
import { EASE } from "./scroll";

export const Reveal = ({ children, delay = 0, y = 36, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, ease: EASE, delay }}
  >
    {children}
  </motion.div>
);

export const SectionHead = ({ eyebrow, title, intro, tone = "dark", className = "", id }) => {
  const light = tone === "light";
  return (
    <div className={`max-w-3xl ${className}`}>
      <Reveal>
        <p className={`eyebrow ${light ? "text-terra-ink" : "text-terra"}`}>{eyebrow}</p>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 id={id} className={`mt-5 font-display text-[2.75rem] font-bold uppercase leading-[0.9] sm:text-6xl lg:text-7xl ${light ? "text-ink" : "text-white"}`}>
          {title}
        </h2>
      </Reveal>
      {intro && (
        <Reveal delay={0.16}>
          <p className={`mt-6 max-w-xl text-base leading-relaxed sm:text-lg ${light ? "text-slate-700" : "text-slate-300"}`}>{intro}</p>
        </Reveal>
      )}
    </div>
  );
};
